import type { SubscriptionTypes } from "@component/Widget/NewsletterSubscribe/NewsletterSubscribe";
import type { ReactNode } from "react";
import React from "react";
import { CorporateBankAccountLeadForm } from "../LeadForm/CorporateBankAccountLeadForm";
import * as Step from "./Steps";

/**
 * @Shortcode
 *
 * @title "Vállalati bankszámla cikkvégi leadform"
 * @shortcode "sme_account_article_lead"
 * @slug "vallalati-szamla-cikkvegi"
 * @type "leadform"
 */
export class CorporateBankAccountArticleLeadForm extends CorporateBankAccountLeadForm {
	protected readonly subscriptionTypes: SubscriptionTypes[] = ["CORPORATE_NEWSLETTER"];

	public static defaultProps = {
		title: "Szeretném igénybe venni a Bankmonitor segítségét Vállalati számla vonatkozásában:",
		colorScheme: "light",
		fluid: true,
	};

	protected renderSteps(): ReactNode {
		const { title } = this.props;
		const {
			values: { email },
			submitState,
		} = this.state;

		return (
			<>
				<Step.LeadForm
					stepName="lead-form"
					defaultTarget="success-lead"
					title={title}
					questionPlaceholder="Megoldandó vállalati számla igényem"
					submitState={submitState}
				/>
				<Step.SuccessPage
					stepName="success-lead"
					userEmail={email}
					subscriptionTypes={this.subscriptionTypes}
				/>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.CorporateBankAccountArticleLeadForm`;
	}
}
export default CorporateBankAccountArticleLeadForm;
